import { useState } from "react";
import type { Snapshot } from "../types";

/** Preserve the visit's marker even after a bottom-of-view receipt clears unread. */
export function useUnreadBoundary(
  data: Snapshot | undefined,
  open: boolean,
  memberId: string,
) {
  const [visit, setVisit] = useState<{
    open: boolean;
    lastRead: string | null;
    count: number;
  }>({ open, lastRead: data?.lastRead ?? null, count: data?.unreadCount ?? 0 });
  if (visit.open !== open)
    setVisit({
      open,
      lastRead: open ? (data?.lastRead ?? null) : null,
      count: open ? (data?.unreadCount ?? 0) : 0,
    });
  else if (
    open &&
    data &&
    (visit.lastRead === null || (visit.count === 0 && data.unreadCount > 0))
  )
    setVisit({ open, lastRead: data.lastRead, count: data.unreadCount });
  const messages =
    visit.lastRead === null
      ? []
      : (data?.messages ?? []).filter(
          (message) =>
            !message.deleted &&
            message.memberId !== memberId &&
            BigInt(message.noticeSeq) > BigInt(visit.lastRead!),
        );
  return {
    firstRoot: messages[0]?.rootId,
    count: Math.max(visit.count, messages.length),
    ready: !open || !data || visit.lastRead !== null,
  };
}
